<div *ngIf="formName && ((formName.invalid && submitted) || (formName.dirty && formName.invalid))">
  <small class="p-error" *ngIf="formName?.errors?.required">
    {{'common.validation.required' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.minlength">
    {{'common.validation.minLength' | translate:{field: (message | translate) , value: formName.errors.minlength.requiredLength} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.maxlength">
    {{'common.validation.maxLength' | translate:{field: (message | translate) , value: formName.errors.maxlength.requiredLength} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.min">
    {{'common.validation.min' | translate:{field: (message | translate) , value: formName.errors.min.min} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.max">
    {{'common.validation.max' | translate:{field: (message | translate) , value: formName.errors.max.max} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.pattern">
    {{'common.validation.pattern' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.onlyNaturalNumber">
    {{'common.validation.onlyNaturalNumber' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.space">
    {{'common.validation.space' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.onlyNumber">
    {{'common.validation.onlyNumber' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.onlyDoubleNumber">
    {{'common.validation.onlyDoubleNumber' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.onlyCharacter">
    {{'common.validation.onlyCharacter' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.mustMatch">
    {{'common.validation.mustMatch' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.passwordMustMatchChange">
    {{'common.validation.mustMatch' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.email">
    {{'common.validation.email' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.existCheck">
    {{'common.validation.existCheck' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.date">
    {{'common.validation.date' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.multidate">
    {{'common.validation.multidate' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.passwordNotMatch">
    {{'common.validation.passwordNotMatch' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.dateVaidator">
    {{'common.validation.date' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.requireUppercase">
    {{'common.validation.requireUppercase' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.requireLowercase">
    {{'common.validation.requireLowercase' | translate:{field: (message | translate)} }}
  </small>
  <small class="p-error" *ngIf="formName?.errors?.requireSpecialChar">
    {{'common.validation.requireSpecialChar' | translate:{field: (message | translate)} }}
  </small>
</div>
